import { render, staticRenderFns } from "./WebsiteLink.vue?vue&type=template&id=2bd62fd6&"
import script from "./WebsiteLink.vue?vue&type=script&lang=ts&"
export * from "./WebsiteLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports